import { useNavigate } from 'react-router-dom';
import { ArrowRight, Star, CheckCircle } from '../icons';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="pt-28 pb-16 md:pt-32 md:pb-24 px-4 md:px-8 bg-brand-5">
      <div className="max-w-[1216px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 relative">
            <div className="relative max-w-md mx-auto lg:mx-0">
              <div className="absolute -top-4 -left-4 w-full h-full bg-success-10 rounded-[32px] transform rotate-3" />
              <div className="relative bg-white rounded-[32px] shadow-soft-lg overflow-hidden">
                <div className="p-6 border-b border-gray-20">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-brand-10 rounded-full flex items-center justify-center">
                      <span className="text-2xl">🎯</span>
                    </div>
                    <div>
                      <p className="text-sm text-gray-40">Assessment</p>
                      <p className="font-semibold text-gray-80">
                        How would you describe yourself?
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <div className="flex-1 h-2 bg-success-40 rounded-full" />
                    <div className="flex-1 h-2 bg-success-10 rounded-full" />
                    <div className="flex-1 h-2 bg-success-10 rounded-full" />
                  </div>
                </div>
                <div className="p-6 space-y-3">
                  {[
                    'I am confident in my abilities',
                    'I embrace new challenges',
                    'I connect easily with others',
                  ].map((text, i) => (
                    <div
                      key={i}
                      className={`flex items-center gap-3 p-4 rounded-xl border transition-all ${
                        i === 0
                          ? 'border-success-40 bg-success-5'
                          : 'border-gray-20 hover:border-gray-30'
                      }`}
                    >
                      <CheckCircle
                        className={`w-5 h-5 ${
                          i === 0 ? 'text-success-40' : 'text-gray-30'
                        }`}
                      />
                      <span className="text-gray-60 text-sm">{text}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-soft p-4 hidden md:block">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-orange-10 rounded-full flex items-center justify-center">
                    <span className="text-lg">✨</span>
                  </div>
                  <div>
                    <p className="text-xs text-gray-40">Insights</p>
                    <p className="text-sm font-semibold text-gray-80">
                      AI Analysis
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <Badge variant="brand" className="mb-6">
              <Star className="w-4 h-4 mr-1 fill-brand-40 text-brand-40" />
              Personality Assessment
            </Badge>

            <h1 className="text-4xl md:text-5xl lg:text-heading-xl font-bold text-brand-90 mb-6 leading-tight">
              Understand Your True Potential.{' '}
              <span className="text-success-40">Anytime, Anywhere.</span>
            </h1>

            <p className="text-lg md:text-paragraph-xl text-gray-60 mb-8 max-w-xl mx-auto lg:mx-0">
              Personality assessments shape daily clarity, not just major
              milestones. Human Potential OS is your partner in wholeness, growth, and
              career success. Designed to help you understand, manage, and
              improve your personal potential journey.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                onClick={() => navigate('/register')}
                className="gap-2"
              >
                Start Assessment
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={() => navigate('/example')}
              >
                View Example Results
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
